import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'
import { buildRoomPackageOptionsViewOrder } from 'lib/offer/offerPageUtil'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getDurationPackageOptions, OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import AccommodationRoomTile from 'components/OfferPage/Accommodation/AccommodationRoomTile'
import AccommodationRoomTileImage from 'components/OfferPage/Accommodation/AccommodationRoomTileImage'
import FlashHotelAboutRoomModalTab from './FlashHotelAboutRoomModalTab'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import FlashHotelRoomSelectionButton from '../FlashHotelRoomSelectionButton'

const StyledModalContent = styled(ModalContent)`
  padding: 0;
`

interface Props {
  room: App.PackageRoomType;
  packageOptions: Array<OfferPackageOptionView>;
  onClose?: () => void;
  onBack?: () => void;
}

function FlashHotelRoomDetailsModal(props: Props) {
  const { room, packageOptions, onClose, onBack } = props

  const packageOptionsByRoom = useMemo(() => {
    return buildRoomPackageOptionsViewOrder(packageOptions)
  }, [packageOptions])

  const packageViews = packageOptionsByRoom.find(option => option.roomId === room.id)?.packageViews
  const pkg = packageViews?.[0].package
  const { resolve } = useModalElementContext()
  const onCTAClick = useCallback(() => resolve(), [resolve])

  if (!pkg) return null

  return (
    <ModalBase height="max">
      <ModalHeader
        title={room.name}
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      />
      <ModalBody>
        <StyledModalContent>
          <AccommodationRoomTile>
            <AccommodationRoomTileImage
              // @ts-expect-error not HotelPackage
              roomPackage={pkg}
            />
          </AccommodationRoomTile>
          <FlashHotelAboutRoomModalTab pkg={pkg} />
        </StyledModalContent>
      </ModalBody>
      <ModalFooter>
        <FlashHotelRoomSelectionButton onClick={onCTAClick} roomType={pkg.roomType} />
      </ModalFooter>
    </ModalBase>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  packageOptions: getDurationPackageOptions(state, appState),
}))(FlashHotelRoomDetailsModal)
